import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import SingleBook from "../components/books/SingleBook";
import { useGetBooksQuery } from "../features/api/apiSlice";
import { type } from "../features/filter/filterSlice";
function Home() {
  const { data, isLoading, error, isSuccess } = useGetBooksQuery();
  const dispatch = useDispatch();

  const [displayedBooks, setDisplayedBooks] = useState([]);

  const { featured, searchTerm } = useSelector((state) => state.filter);
  function handleFeatureChange(feature) {
    dispatch(type(feature));
  }

  useEffect(() => {
    if (isSuccess) {
      let duplicateData = [...data];
      if (featured === "Featured") {
        duplicateData = duplicateData?.filter((book) => book.featured === true);
      }
      if (searchTerm !== "") {
        duplicateData = duplicateData?.filter((book) =>
          book?.name?.toLowerCase()?.includes(searchTerm?.toLowerCase())
        );
      }
      setDisplayedBooks(duplicateData);
    }
  }, [isSuccess, featured, searchTerm, data]);

  let content = null;
  if (isLoading) content = "Loading....";
  if (!isLoading && error) content = "Something went wrong!";
  if (!isLoading && !error && displayedBooks?.length === 0)
    content =
      featured === "All" && searchTerm === ""
        ? "No Books Yet.."
        : "No Books Found!";
  if (!isLoading && !error && displayedBooks?.length > 0)
    content = displayedBooks?.map((book) => (
      <SingleBook book={book} key={book.id} />
    ));

  return (
    <main className="py-12 px-6 2xl:px-6 container">
      <div className="order-2 xl:-order-1">
        <div className="flex items-center justify-between mb-12">
          <h4 className="mt-2 text-xl font-bold">Book List</h4>

          <div className="flex items-center space-x-4">
            <button
              className={`lws-filter-btn ${
                featured === "All" && "active-filter"
              } `}
              onClick={() => handleFeatureChange("All")}
            >
              All
            </button>
            <button
              className={`lws-filter-btn ${
                featured === "Featured" && "active-filter"
              } `}
              onClick={() => handleFeatureChange("Featured")}
            >
              Featured
            </button>
          </div>
        </div>
        <div className="space-y-6 md:space-y-0 md:grid grid-cols-1 lg:grid-cols-3 gap-6">
          {content}
        </div>
      </div>
    </main>
  );
}

export default Home;
